module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-list",
    class: {
      horizontal: _vm.horizontal
    }
  }, _vm._l((_vm.schema), function(field, fieldIndex) {
    return _c('div', {
      key: fieldIndex,
      style: (_vm.sectionStyle(field))
    }, [_c('DynamicControl', {
      key: fieldIndex,
      attrs: {
        "value": _vm.value[field.name],
        "context": _vm.context,
        "record": _vm.value,
        "schema": field
      },
      on: {
        "change": function($event) {
          var i = arguments.length, argsArray = Array(i);
          while ( i-- ) argsArray[i] = arguments[i];

          return _vm.emitChanges.apply(void 0, argsArray.concat( [field.name] ))
        }
      }
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a59e42a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/ControlList.vue
// module id = 2489
// module chunks = 1